'use no memo';
import { useIsDataClassificationEnabledForOrg } from './useIsDataClassificationEnabledForOrg.ts';

export const useIsClassificationEnabledForContentTypeExpansion = (
	_contentType: string,
	_isLivePage: boolean = false,
	shouldSkipEnablementQuery: boolean = false,
): boolean => {
	const { isEnabled: isClassificationEnabledForOrg } = useIsDataClassificationEnabledForOrg({
		skip: shouldSkipEnablementQuery,
	});

	// Classification is enabled for all content types as long as it is enabled for the org.
	return isClassificationEnabledForOrg;
};
